import { gql } from '@apollo/client';
import { CHARGE_PRICE_FRAGMENT } from './chargePriceFragment';

export const QUOTE_EQUIPMENT_FRAGMENT = gql`
  fragment QuoteEquipmentFields on QuoteEquipmentResponse {
    equipmentId
    externalId
    vin
    stockNumber
    cost
    attributes {
      key
      value
      description
    }
    price {
      ...ChargePriceFields
    }
  }
  ${CHARGE_PRICE_FRAGMENT}
`;
